'use strict'

import VacancyApi from './../../api/vacancy.js'

const state = {
  data: null,
  loading: false,
  error: null,
  changed: false
}

const getters = {
}

const actions = {
  fetch ({commit}, vacancy) {
    commit('request')

    VacancyApi.vacancyDescriptionGetData(vacancy)
    .then(data => commit('success', data))
    .catch(error => commit('failure', error))
  },

  update ({commit}, data) {
    commit('update', data)
  },

  save ({commit, state}, vacancy) {
    if (state.changed) {
      commit('request')
      VacancyApi.vacancyDescriptionUpdate(vacancy, state.data)
      .then(data => commit('success', data))
      .catch(error => commit('failure', error))
    } else {
      // do nothing, because, nothig was changed in object, no need to send save request
    }
  }
}

const mutations = {
  request (state) {
    state.loading = true
    state.error = null
    state.changed = false
  },

  failure (state, error) {
    state.loading = false
    state.error = error
  },

  success (state, data) {
    state.loading = false
    state.data = data
  },

  update (state, {field, value}) {
    // flag determine that some fields was changed
    state.changed = true
    // in case of data is not defined, set it as empty object
    if (!state.data) {
      state.data = {}
    }

    state.data[field] = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
